import { useMemo, useCallback } from 'react';
import { useRouter } from 'next/router';

//* HOC's
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Helpers
import { routerToPathAndQuery } from 'helpers/_routerToPathAndQuery';
import { usePreserveScroll } from 'helpers';

//* Components
import Container from 'components/common/Container';
import Page from 'components/common/Page';
import Text from 'components/common/Text';
import FilterBar from 'components/pages/events/FilterBar';
import RelatedBlogPosts from 'components/common/RelatedBlogPosts';
import Empty from 'components/common/Empty';

//* Styles
import EventStyle from 'styles/pages/EventsStyle';

const Articles = ({ pages, dataProviderState, pageParams, selectedLang }) => {
	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name]);
	const articlesData = useMemo(
		() => dataProviderState?.articles?.[pageParams?.queryName]?.[selectedLang],
		[dataProviderState, selectedLang, pageParams.queryName]
	);

	//! Router
	const router = useRouter();

	//! Query Param Keys
	const queryParamKeys = useMemo(() => pageParams.postType.queryParamKeys, [pageParams]);

	//! On Category Change
	const onCategoryChange = useCallback(
		(type, typeId, multiple = false) => {
			const { pathname, query } = routerToPathAndQuery(router, type, typeId, multiple);

			router.push({ pathname, query }, undefined, { scroll: false });
		},
		[router.query]
	);

	usePreserveScroll();

	return (
		<Page
			nextSeoProps={{
				noindex: selectedLang == 'fr' || selectedLang == 'hy',
			}}
			hrefLang={false}
			meta={pageData?.content?.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}>
			{pageData && (
				<EventStyle>
					<Container className='main-container'>
						<div className='page-top'>
							<Text
								tag={'h3'}
								className={'select-outer-text font-ping-bolder'}
								text={pageData?.content?.title || 'popularEventsIn'}
							/>
						</div>

						<FilterBar
							queryParamKeys={queryParamKeys}
							categories={pageData.categories}
							tags={pageData.tags}
							onCategoryChange={onCategoryChange}
							disableDatePicker
							resetUrl={pageParams.path}
						/>
					</Container>

					{articlesData?.articles.length !== 0 ? (
						<RelatedBlogPosts
							className='articles-page-items-wrap'
							blogListing
							hasMore={articlesData?.hasMore}
							router={router}
							articles={articlesData?.articles}
							onCategoryChange={onCategoryChange}
							pageParams={pageParams}
						/>
					) : (
						<Empty hasSubtitle={false} />
					)}
				</EventStyle>
			)}
		</Page>
	);
};

export default withDataContext(Articles, ['pages', 'dataProviderState']);
